export default "__VITE_ASSET__VGLx1tej__"